<template lang="pug">
.service-content
  .service-content-container

    .service-content__desc
      .content__desc__title {{ $t('采买运营一站式服务') }}
      .content__desc {{ $t('合理的采买价格以及专业的运营团队，给到您一站式的广告投放服务。') }}
      .content__desc {{ $t('已为拜耳虫虫拜拜、KitchenAid、泰克科技等广告主提供采买运营服务。') }}

    .service-container__subTitle
      img(src="@/assets/icon-challenge.png")
      .subTitle {{ $t('企业面临的挑战与痛点') }}

    .service-challenge-container.service-challenge-container__min
      .challenge__item
        img(
          src="@/assets/service-challenge-img.png"
        )
        i.iconfont.iconjiage(
          style="width: 23px"
        )
        .item__title {{ $t('询价困难') }}
        .item__desc {{ $t('目前市面上平台以及代理商较为繁多，针对媒体没有统一的采买价格，以及代理商报价不透明的情况，同时询价的渠道较少，很难进行大范围的询价。') }}
      .challenge__item
        img(
          src="@/assets/service-challenge-img.png"
        )
        i.iconfont.iconpinggu(
          style="width: 17px"
        )
        .item__title {{ $t('供应商估价') }}
        .item__desc {{ $t('由于各个投放渠道的运营商较多，广告主难以去逐一衡量运营商质量，或会耗费大量的时间去对运营商进行评估，从而会消耗不必要的时间或者投放预算。') }}
    .service-container__subTitle
      img(src="@/assets/icon-project.png")
      .subTitle {{ $t('复歌的解决方案') }}

    .service-solution-container
      .solution-item
        img(
          src="@/assets/service-ad-1.png"
        )
        .solution-content
          .solution-content__title {{ $t('渠道整合') }}
          .solution-content__desc {{ $t('复歌拥有自主开发的渠道媒体平台“贵了么”，对各类的广告渠道以及广告代理商如：今日头条、抖音、快手、微博开屏等渠道进行整合，拥有较为全面并且透明的渠道报价。')}}

      .solution-item
        .solution-content
          .solution-content__title {{ $t('专业的运营团队') }}
          .solution-content__desc {{ $t('复歌拥有专业的广告运营团队，针对各个渠道均有丰富的运营经验，可以根据广告中的具体投放目标，提供全方位的优化方案以及专业的服务。') }}
        img(
          src="@/assets/service-ad-2.png"
        )
  CaseSample(
    :data="caseList"
  )
</template>

<script>
import CaseSample from '@/components/CaseSample'
export default {
  components: {
    CaseSample
  },
  data () {
    return {
      caseList: [
        {
          url: '/case/ad-bayer',
          img: require('@/assets/case-bayer.png'),
          title: '虫虫拜拜',
          desc: '从供应商选择到数据展示的一站式解决方案。'
        },
        {
          url: '/case/viking',
          img: require('@/assets/case-viking.png'),
          title: '维京游轮',
          desc: '为维京游轮提供广告及网站监测，收集整合媒体及销售数据并进行挖掘和分析。'
        },
        {
          url: '/case/tektronix',
          img: require('@/assets/case-tektronix.png'),
          title: '泰克科技',
          desc: '为TeKtronix提供广点通及微信广告投放服务。'
        }
      ]
    }
  }
}
</script>
